import styled from 'styled-components';

const cores = {
    sucess: 'var(--successColor)',
    atual: 'var(--primaryColor)'
};

export const Container = styled.div`
    display: flex;
    flex-direction: row;

    justify-content: space-between;
    align-items:center;

    height: 100%;
    width: 100%;
    user-select: none;
    border-radius: 5px;
    overflow: hidden;
`;

export const Etapa = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px 5px;
`;

export const NumeroEtapa = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    padding: ${ props => props.passou ? '3px' : '10px' };
    margin-right: 5px;
    width: 25px;
    height: 25px;

    background: ${ props => !props.atual && !props.passou ? 'var(--backgroundColorHover);' : props.atual ? cores.atual : cores.sucess };

    color: ${ props => props.atual || props.passou ? '#fff;' : 'var(--textBlack);' };
    border-radius: 50%;

    font-size: 16px;
    font-weight: 600;
`;

export const StringEtapa = styled.div`
    font-size: 16px;
    font-weight: 600;
    white-space: nowrap;
    @media (max-width: 1200px) {
        white-space: pre-line;
    }
    color: ${ props => !props.atual && !props.passou ? 'var(--textBlack);' : props.atual ? cores.atual : '#b7b7b7;' };
`;

export const Linha = styled.div`
    margin: 0 30px;
    height: 2px;
    max-width: 20%;
    width: 100%;

    background: ${ props => props.marcada ? 'linear-gradient(to bottom right, #80ff83 0%, #3a70e8 100%);' : 'var(--textBlack)' };

    @media (max-width: 768px) {
        display: none;
    }
`;
export const BtnAvancarVoltar = styled.div`
    cursor: pointer;
    text-Align: center;
    padding: 0px 10px;
    height:100%;

    font-Weight: 600;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    transition-duration: .3s;
    color: #fff;
    background: ${ props => props.avancar ? 'var(--successColor)' : 'var(--cancelColor)' } ;

    white-space: nowrap;
    :hover{
        background:${ props => props.avancar ? '#00881f' : 'var(--cancelColorHover)' };
    }
`;
